import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SrtStream } from '../../../stores/reducers/video';
import { GreenroomState as GS } from '../../../stores/types/types';
import FeedSrtStream from './feed-srt-stream';
import useShots from '../../../contexts/shots/provider';

interface Props {
	feedPosition: number;
	mediaId: number;
}

function FeedSrtStreamSpotlight(props: Props) {
	const { feedPosition, mediaId } = props;
	const srtStreams = useSelector((s: GS) => s.VideoReducer.srtStreams);
	const { currentShot: { shot_data: { shotFeeds } } } = useShots();

	const srtStream = useMemo(
		() => srtStreams.find((ls: SrtStream) => ls.id === mediaId),
		[srtStreams, mediaId],
	);

	const audioOnly = useMemo(
		() => !!shotFeeds.find((feed) => feed.srtStreamId === mediaId)?.audioOnly,
		[shotFeeds, feedPosition],
	);

	return (
		<FeedSrtStream
			feedPosition={feedPosition}
			srtStream={srtStream}
			audioOnly={audioOnly}
			isSpotlightFeed={true}
			dropCallback={() => {}}
		/>
	);
}

export default memo(FeedSrtStreamSpotlight);
